import canvasManager from "slotworks/graphics/canvas/canvas-manager";
import Layers from "slotworks/graphics/layers/layers";

export default class LayerDebugger {

    private groupElement: HTMLDivElement;

    public start() {
        this.draw();
        this.updateLayers();
    }

    public toggle() {
        if (!this.groupElement) {
            this.start();
        } else {

            if (this.groupElement.parentElement) {
                canvasManager.rootNode.removeChild(this.groupElement);
            } else {
                canvasManager.rootNode.appendChild(this.groupElement);
            }
        }
    }

    private draw() {
        this.groupElement = document.createElement("div");
        this.groupElement.id = "LayerDebugger-groups";

        this.groupElement.style.position = "fixed";
        this.groupElement.style.top = "0";
        this.groupElement.style.right = "18vw";
        this.groupElement.style.zIndex = "900";
        this.groupElement.style.width = "15vw";
        this.groupElement.style.paddingTop = "3vh";
        this.groupElement.style.paddingLeft = "3vw";
        this.groupElement.style.pointerEvents = "all";

        this.groupElement.style.backgroundColor = "rgba(50,50,50,.5)";
        this.groupElement.style.border = "solid 1px white";

        this.groupElement.style.color = "#fff";
        this.groupElement.style.fontSize = "16px";

        canvasManager.rootNode.appendChild(this.groupElement);
    }

    private updateLayers() {
        while (this.groupElement.firstChild) {
            this.groupElement.removeChild(this.groupElement.firstChild);
        }

        let i = 0;

        const names: string[] = [];

        Layers.Debug.container.parent.children.forEach((child) => {
            names.push(child.name);
        });

        names.reverse();

        names.forEach((name) => {

            const label = document.createElement("div");

            label.innerText = ` ${i}: ${name}`;

            label.style.color =  "white";

            this.groupElement.appendChild(label);

            i++;
        });
    }

}
